import {StepType} from '@reactour/tour';
import {eventCreateSteps} from 'src/modules/ai/tour/steps/event-create-steps';
import {eventUpdateSteps} from 'src/modules/ai/tour/steps/event-update-steps';
import {EventCreationMode} from 'src/modules/event-create/constants';

export const stepsByMode: Record<EventCreationMode, StepType[]> = {
    [EventCreationMode.create]: eventCreateSteps,
    [EventCreationMode.update]: eventUpdateSteps,
};
